<template>
    <div class="padding-10">
        <a-divider orientation="left">场站综合报表</a-divider>
        <div class="search-div">
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="12">

                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="时间类型">
                                <a-select class="dateType" v-model="queryParam.dateType" defaultValue="1" @change="changeDateType">
                                    <a-select-option v-for="item in selectData.dateType" :key="item.id"
                                                     :value="item.id">{{item.name}}
                                    </a-select-option>
                                </a-select>

                            </a-form-item>
                        </a-col>

                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="时间范围">
                               <select-date ref="selectDate" @getDateRange="getDateRange"></select-date>
                            </a-form-item>
                        </a-col>




                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label=" " :colon="false">
                             <span class="table-page-search-submitButtons">
                              <a-button type="primary" @click="initTable">查询</a-button>
                             </span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </div>

        <div class="table-tools">
            <a-form layout="inline" >

                <a-form-item>
                    <a-button-group>
                        <a-button @click="exportData"><i class="fa fa-cloud-download icon"></i> 导出</a-button>
                    </a-button-group>
                </a-form-item>
            </a-form>


            <div class="table-tools-right">
                <a-icon type="sync" @click="initTable" />
                <table-columns :columns="columns" @getFilterColumns="getColumns" :rowKey="record=>record.id">
                </table-columns>
            </div>
        </div>
        <a-table :loading="loading"
                 :columns="filterColumns"
                 :dataSource="data"
                 bordered
                 @change="changeOrder"
                 :pagination="pagination"
        >
                   <span slot="id" slot-scope="text, record, index">
                        <template>
                            <span>{{index + 1}}</span>
                        </template>
                  </span>
        </a-table>
    </div>
</template>

<script>
    import TableColumns from "@/components/TableColumn/TableColumns";
    import stationSelectList from "../../../components/common/stationSelectList";
    import dateRange from "../../../components/common/dateRange";
    import selectDate from "@/components/selectDate/selectDate";


    const columns = [
        {
            title: 'id',
            key: 'id',
            dataIndex: 'id',
            show: true,
            sorter: true,
            scopedSlots: {customRender: "id"},
        },
        {
            title: '场站名称',
            key: 'powerStationName',
            dataIndex: 'powerStationName',
            show: true,
            sorter: true
        },

        {
            title: '组件容量(kWp)',
            key: 'capacity',
            dataIndex: 'capacity',
            show: true,
            sorter: true
        },
        {
            title: '发电量(kWh)',
            key: 'elecCap',
            dataIndex: 'elecCap',
            show: true,
            sorter: true
        },
        {
            title: '发电小时(h)',
            key: 'elecHour',
            dataIndex: 'elecHour',
            show: true,
            sorter: true
        },
        {
            title: '最高温(°C)',
            key: 'maxTemp',
            dataIndex: 'maxTemp',
            show: true,
            sorter: true
        },
        {
            title: '最低温(°C)',
            key: 'minTemp',
            dataIndex: 'minTemp',
            show: true,
            sorter: true
        },
        {
            title: '平均PR(%)',
            key: 'avgPR',
            dataIndex: 'avgPR',
            show: true,
            sorter: true
        },
        {
            title: '场站类型',
            key: 'typeName',
            dataIndex: 'typeName',
            show: true,
            sorter: true
        },
        {
            title: '电压等级(V)',
            key: 'currentLevel',
            dataIndex: 'currentLevel',
            show: true,
            sorter: true
        },
        {
            title: '统计时间',
            key: 'statTime',
            dataIndex: 'statTime',
            show: true,
            sorter: true
        }


    ];

    export default {
        name: "stationReport",
        components:{
            TableColumns,
            stationSelectList,
            dateRange,
            selectDate
        },
        data(){
            return {
                labelCol: {
                    span: 6
                },
                columns,
                data: [],
                filterColumns:[],
                haha: '',
                queryParam:{
                    station: 0,
                    startTime: 'null',
                    endTime: 'null',
                    dateType: 3,
                },
                selectData: {
                    station: [],
                    dateType: [
                        {
                            id: 3,
                            name: '日'
                        },
                        {
                            id: 2,
                            name: '月'
                        },
                        {
                            id: 1,
                            name: '年'
                        }
                    ],
                },
                queryParams:{
                    sortName: 'id',
                    sortOrder: 'asc',
                    page: 1,
                    size: 10
                },
                order: {
                    ascend: 'asc',
                    descend: 'desc'
                },
                loading: false,
                stationName: '',
                pagination: {
                    total: 0,
                    current: 1,
                    // defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10','20','50','100']
                },
                groupId: this.$Utils.getUserStorage().groupId,
                stationId: this.$Utils.getUserStorage().powerStationId,
                username: null
            }
        },
        mounted(){
            this.username = this.$Utils.getUserStorage().username;
            this.groupId = this.$Utils.getUserStorage().groupId;
            this.initTableColumns();
            this.initTable();
        },
        methods:{
            initTableColumns(){
                this.filterColumns = this.columns.filter(item => item.show);
            },

            getColumns(data){
                this.filterColumns = data;
            },

            changeOrder(pagination, filters, sorter){
                console.log(pagination ,sorter)
                this.queryParams.page = pagination.current;
                this.queryParams.sortName = sorter.columnKey ? sorter.columnKey : 'id';
                this.queryParams.sortOrder = sorter.order ? this.order[sorter.order] : 'desc';
                this.initTable()
            },

            async initTable(){
                this.loading = true;
                let result = await this.$http.get(this.$baseURL.stationIntegratedReport({powerStationId: this.stationId, timeDimension: this.queryParam.dateType, beginTimeNum: this.queryParam.startTime,endTimeNum: this.queryParam.endTime}, this.queryParams));
                console.log(result)
                this.data = result.list;
                this.pagination.current = result.pageNum;
                this.pagination.total = result.total;
                this.loading = false;

                console.log(this.pagination)
            },


            changeDateType(){
                this.initTable();
                this.$refs.selectDate.init(this.queryParam.dateType);
            },

            getDateRange(date){
                console.log(date)
                this.queryParam.startTime = date.start;
                this.queryParam.endTime = date.end;
                this.initTable();
            },

            changeDate(start, end){
                this.queryParam.startTime = start;
                this.queryParam.endTime = end;
                console.log(this.queryParam.startTime, this.queryParam.endTime)
                this.initTable();
            },
            async exportData(){
                let result = await this.$http.get(this.$baseURL.stationExportExcel({groupId: this.groupId, powerStationId: this.stationId, username: this.username}), 1)
                this.$Utils.showInfo({title: '文件下载', msg: '生成文件需要一点时间,完成后会自动下载...'})
            }

        },
        computed:{
            wrapperCol(){
                return {span: 24 - this.labelCol.span};
            }
        }
    }
</script>

<style scoped>

</style>
